import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useDashboard } from '../../DashboardContext';
import { S } from '../../lib/constants';

export default function BenchmarksSection() {
  const {
    showBenchmark, setShowBenchmark,
    dcaBtcEnabled, setDcaBtcEnabled,
    dcaSpEnabled, setDcaSpEnabled,
    dcaSpReturn, setDcaSpReturn,
    equivalentDCA,
    fmt,
  } = useDashboard();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-2">
        <label className="flex items-center gap-2 text-sm cursor-pointer" style={{ color: '#525252' }}>
          <input type="checkbox" checked={showBenchmark} onChange={(e) => setShowBenchmark(e.target.checked)} className="rounded" />
          Show DCA Benchmarks in Charts
        </label>
      </div>

      <div className="text-xs" style={{ color: '#737373', fontStyle: 'italic' }}>
        DCA amounts mirror your active mining strategy's cash outflows dollar for dollar: the same CapEx, OpEx, and loan payments, deployed into BTC or the S&P 500 instead of mining.
        {equivalentDCA && <span style={{ color: '#525252' }}> Total deployed: <strong>{fmt(equivalentDCA.totalCashDeployed)}</strong></span>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* BTC DCA */}
        <div style={S.card}>
          <div className="p-5">
            <div className="flex items-center gap-2 mb-4">
              <input type="checkbox" checked={dcaBtcEnabled} onChange={(e) => setDcaBtcEnabled(e.target.checked)} className="rounded" />
              <h3 className="font-semibold flex items-center gap-2" style={{ color: '#525252', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                <TrendingUp className="w-4 h-4" style={{ color: '#92700C' }} /> DCA into BTC
              </h3>
            </div>
            {dcaBtcEnabled && (
              <div className="text-xs" style={{ color: '#737373' }}>
                Uses the same BTC price scenario as your mining strategy for a true 1:1 comparison.
              </div>
            )}
          </div>
        </div>

        {/* S&P 500 DCA */}
        <div style={S.card}>
          <div className="p-5">
            <div className="flex items-center gap-2 mb-4">
              <input type="checkbox" checked={dcaSpEnabled} onChange={(e) => setDcaSpEnabled(e.target.checked)} className="rounded" />
              <h3 className="font-semibold flex items-center gap-2" style={{ color: '#525252', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                <TrendingUp className="w-4 h-4" style={{ color: '#16A34A' }} /> DCA into S&P 500
              </h3>
            </div>
            {dcaSpEnabled && (
              <div>
                <label className="block mb-1.5 font-medium" style={{ color: '#525252', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '11px', fontFamily: "'IBM Plex Mono', monospace" }}>Annual Return %</label>
                <input type="number" value={dcaSpReturn} onChange={(e) => setDcaSpReturn(Number(e.target.value))}
                  min={0} max={30} step={1}
                  className="w-full px-3 py-2 text-sm focus:outline-none transition-colors"
                  style={{ background: '#F5F5F5', border: '1px solid #E5E5E5', borderRadius: '4px', color: '#1A1A1A', fontFamily: "'IBM Plex Mono', monospace" }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
